import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { TaxRateForSelectFragment } from 'generated/resources/graphql'

import NumberField from 'modules/core/components/NumberField'
import TextField from 'modules/core/components/TextField'
import { FormErrors } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { LineItem } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/SaleInvoiceForm/types'
import { TaxRateEntitySelector } from 'modules/finance/components/TaxRateEntitySelector'

interface LineItemFieldsProps {
  lineItem: LineItem
  errors?: FormErrors<LineItem>
  onChange: (field: string, value: string | TaxRateForSelectFragment | number | null) => void
  currency?: string
  country?: string
}

function sanitizePositiveNumber(value: number | undefined | null, defaultValue: number) {
  if (typeof value !== 'number') return defaultValue
  if (value < 0) return value * -1
  return value || defaultValue
}

const LineItemFields: React.FC<LineItemFieldsProps> = ({
  lineItem,
  errors,
  onChange,
  currency,
  country,
}) => (
  <>
    <TextField
      mandatory
      type="text"
      value={lineItem.description || ''}
      label={i18n.t('finance.sale_invoices.form.line_items.item')}
      placeholder={i18n.t('finance.sale_invoices.form.line_items.item_name')}
      onChange={(description) => onChange('lineItem.description', description)}
      error={errors?.description}
    />
    <NumberField
      mandatory
      maxDecimals={2}
      step={0.01}
      min={0}
      value={lineItem.amount}
      placeholder="0"
      label={i18n.t('finance.sale_invoices.form.line_items.price')}
      indicator={
        currency && (
          <Text.Normal size="200" color="grey600" weight="medium">
            {currency}
          </Text.Normal>
        )
      }
      onChange={(amount) => onChange('lineItem.amount', sanitizePositiveNumber(amount, 0))}
      error={errors?.amount}
    />
    <Box flexDirection="row" gap="s12">
      <NumberField
        mandatory
        maxDecimals={2}
        step={0.01}
        min={1}
        value={lineItem.quantity}
        placeholder="0"
        label={i18n.t('finance.sale_invoices.form.line_items.quantity')}
        onChange={(quantity) => onChange('lineItem.quantity', sanitizePositiveNumber(quantity, 1))}
        error={errors?.quantity}
      />
      <TaxRateEntitySelector
        mandatory
        label={i18n.t('finance.sale_invoices.form.line_items.tax_rate')}
        value={lineItem.taxRate ?? null}
        onChange={(taxRate) => onChange('lineItem.taxRate', taxRate)}
        source={'system'}
        hideSearchIcon
        type={'vat'}
        country={country}
        error={errors?.taxRate}
      />
    </Box>
  </>
)

export default LineItemFields
